<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'

export default {
  name: 'CardStat',
  props: {
    title: {
      type: String,
      default: '卡片存量分布'
    },
    k: {
      type: String,
      default: 'count'
    },
    name: {
      type: String,
      default: '数量'
    },
    color: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      colorArr: ['#00BFFF', 'red'],
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: [this.colorArr[this.color]],
        title: {
          text: this.title
        },
        xAxis: {
          name: '分类',
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 45 // 标签旋转45度
          }
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: this.name,
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            itemStyle: {
              // 设置柱子宽度
              barWidth: '50%'
            }
          }
        ]
      }
    },
    refresh(data, cardInfo) {
      const time = []
      const card = []
      for (const i in data) {
        const val = data[i]
        time.push(cardInfo[val.cid].name)
        card.push(val[this.k])
      }
      if (this.k === 'user') {
        this.option.series[0].type = 'line'
      }
      this.option.xAxis.data = time
      this.option.series[0].data = card
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
